<template>
  <div class="container-nav container-breadcrumb px-0 float-left w-100 shadow-sm">
    <ul class="list-inline">
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('homerc1')" v-if="checkTabDispCond('homerc1') && flowType === 'bundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('homerc1')" @click.prevent="breadcrumbRedirectTo('homerc1')">
        <span class="fas fa-home mr-1"></span>
        <span class="label">Home</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('condorc1')" v-if="checkTabDispCond('condorc1') && flowType === 'cabundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('condorc1')" @click.prevent="breadcrumbRedirectTo('condorc1')">
        <span class="fas fa-hotel mr-1"></span>
        <span class="label">Condo</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('rentersrc1')" v-if="checkTabDispCond('rentersrc1') && flowType === 'rabundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('rentersrc1')" @click.prevent="breadcrumbRedirectTo('rentersrc1')">
        <span class="fas fa-building mr-1"></span>
        <span class="label">Renters</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('autorc1')" v-if="checkTabDispCond('autorc1')" @keydown.enter.prevent.stop="breadcrumbRedirectTo('autorc1')" @click.prevent="breadcrumbRedirectTo('autorc1')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas fa-car mr-1"></span>
        <span class="label">Auto</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('listing')" v-if="checkTabDispCond('listing')" @keydown.enter.prevent.stop="breadcrumbRedirectTo('listing')" @click.prevent="breadcrumbRedirectTo('listing')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas fa-listing mr-1">
          <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 9H15V12L14 11.3344L13 12V9H10.5C10.225 9 10 9.225 10 9.5V15.5C10 15.775 10.225 16 10.5 16H17.5C17.775 16 18 15.775 18 15.5V9.5C18 9.225 17.775 9 17.5 9ZM5.5 7H12.5C12.775 7 13 6.775 13 6.5V0.5C13 0.225 12.775 0 12.5 0H10V3L9 2.33437L8 3V0H5.5C5.225 0 5 0.225 5 0.5V6.5C5 6.775 5.225 7 5.5 7ZM7.5 9H5V12L4 11.3344L3 12V9H0.5C0.225 9 0 9.225 0 9.5V15.5C0 15.775 0.225 16 0.5 16H7.5C7.775 16 8 15.775 8 15.5V9.5C8 9.225 7.775 9 7.5 9Z" fill="black"/>
          </svg>
        </span>
        <span class="label">Carrier Matches</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('homerc2')" v-if="!isBothNonEndToEnd && checkTabDispCond('homerc2') && flowType === 'bundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('homerc2')" @click.prevent="breadcrumbRedirectTo('homerc2')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas mr-1" :class="getStatus('homerc2')"></span>
        <span class="label">{{ getHomeCarrierName }}</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('condorc2')" v-if="!isBothNonEndToEnd && checkTabDispCond('condorc2') && flowType === 'cabundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('condorc2')" @click.prevent="breadcrumbRedirectTo('condorc2')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas mr-1" :class="getStatus('condorc2')"></span>
        <span class="label">{{ getHomeCarrierName }}</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('rentersrc2')" v-if="!isBothNonEndToEnd && checkTabDispCond('rentersrc2') && flowType === 'rabundle'" @keydown.enter.prevent.stop="breadcrumbRedirectTo('rentersrc2')" @click.prevent="breadcrumbRedirectTo('rentersrc2')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas mr-1" :class="getStatus('rentersrc2')"></span>
        <span class="label">{{ getHomeCarrierName }}</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('autorc2')" v-if="!isBothNonEndToEnd && checkTabDispCond('autorc2')" @keydown.enter.prevent.stop="breadcrumbRedirectTo('autorc2')" @click.prevent="breadcrumbRedirectTo('autorc2')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas mr-1" :class="getStatus('autorc2')"></span>
        <span class="label">{{ getAutoCarrierName }}</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0 active" v-if="isBothNonEndToEnd && checkTabDispCond('nonendtoend')">
        <span class="fas fa-chevron-right mx-2"></span>
        <span class="fas mr-1 fa-home-auto-bundle-search" v-if="flowType === 'bundle'"></span>
        <span class="fas mr-1 fa-condo-auto-bundle-search" v-if="flowType === 'cabundle'"></span>
        <span class="fas mr-1 fa-renter-auto-bundle-search" v-if="flowType === 'rabundle'"></span>
        <span class="label">Finish on Carrier Platforms</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('checkout')" v-if="checkTabDispCond('checkout')" @keydown.enter.prevent.stop="breadcrumbRedirectTo('checkout')" @click.prevent="breadcrumbRedirectTo('checkout')">
        <span class="fas fa-chevron-right mx-2"></span>
        <!-- <span class="fas fa-shopping-cart-c mr-1"></span> -->
        <span class="fas mr-1" :class="getStatus('checkout')"></span>
        <span class="label">Checkout</span>
      </li>
      <li tabindex="0" class="list-inline-item mr-0" :class="checkCurrentBreadcrumb('confirmation')" v-if="checkTabDispCond('confirmation')" @keydown.enter.prevent.stop="breadcrumbRedirectTo('confirmation')" @click.prevent="breadcrumbRedirectTo('confirmation')">
        <span class="fas fa-chevron-right mx-2"></span><!---<i class="fa-sharp fa-solid fa-chevron-right"></i>-->
        <span class="fas fa-clipboard-check mr-1"></span>
        <span class="label">Confirmation</span>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import commonService from '../../services/common';
import patchData from '../../services/patchData';
import postData from '../../services/postData';
import fetchData from '../../services/fetchData';
export default {
  props: ['navData'],  
  data() {
    return {    
      flowType : '', 
      carrierCode: '',
      homerc1routes: ['/home/name-insured','/home/property-details','/home/structure-details','/home/occupants','/home/prior-insurance','/home/coverages'],
      condorc1routes: ['/condo/name-insured','/condo/property-details','/condo/structure-details','/condo/occupants','/condo/prior-insurance','/condo/coverages'],
      rentersrc1routes: ['/renters/name-insured','/renters/property-details','/renters/structure-details','/renters/occupants','/renters/prior-insurance','/renters/coverages'],
      autorc1routes: ['/auto/name-insured','/auto/vehicles','/auto/drivers','/auto/prior-insurance','/auto/coverage'],
      carriermatchroutes: ['/auto/carrier-matches'],
      homerc2routes: ['/home/hopolicydetails','/home/rc2-policy-details','/home/dwelling','/home/mortgage','/home/coverage','/home/policydetails','/home/non-end-to-end'],
      condorc2routes: ['/condo/non-end-to-end'],
      rentersrc2routes: ['/renters/non-end-to-end'],
      autorc2routes: ['/auto/non-end-to-end'],
      checkoutroutes: ['/auto/bundle/checkout', '/home/checkout', '/auto/checkout'],
      confirmationroutes: ['/home/confirmation', '/auto/confirmation','/auto/bundle/confirmation']
    };
  },
  computed: {
    isBothNonEndToEnd() {
      let autoCarrierType = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
      let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
      return (autoCarrierType === 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER');
    },
    getHomeCarrierName() {
      if(this.$store.getters.getSelectedHomeCarrier) {
        return this.$store.getters.getSelectedHomeCarrier.carrier_name;
      } else {
        return sessionStorage.getItem('selectedCarrierHome') && sessionStorage.getItem('selectedCarrierHome')!=="null" ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_name : '';
      }
    },
    getAutoCarrierName() {
      if(this.$store.getters.selectedAutoCarrier) {
        return this.$store.getters.selectedAutoCarrier.carrier_name;
      } else {
        return sessionStorage.getItem('selectedCarrierAuto') && sessionStorage.getItem('selectedCarrierAuto')!=="null" ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_name : '';
      }
    },
    getCarrierWiseRC2Routes() {
      if (sessionStorage.getItem('autoRC1BindResponse')) {        
        let navigateURL = JSON.parse(sessionStorage.getItem('autoRC1BindResponse')).Navigate;
        let carrierRouteArr = commonService.getRouteName(navigateURL).split('/');
        this.carrierCode =  carrierRouteArr[2];//this.$store.getters.getPageName ?  this.$store.getters.getPageName.substring(0, 4) : this.navData.page_name.substring(0, 4);
        this.autorc2routes = ['/auto/non-end-to-end', '/auto/' + this.carrierCode + '/rc2-contact-details','/auto/' + this.carrierCode +'/rc2-driver-vehicle-details','/auto/' + this.carrierCode +'/rc2-policy-details','/auto/' + this.carrierCode +'//rc2-policy-details'];
        this.checkoutroutes = ['/auto/bundle/checkout', '/home/' + this.carrierCode + '/checkout', '/auto/' + this.carrierCode + '/checkout'];
      }
      return true;
    }
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
  },
  methods: {
    getStatus(navItem) {
      let className = '';

      if (navItem === 'homerc2') {
        className = typeof this.navData.tab_buttons !== 'undefined' && (Object.values(this.navData.tab_buttons).filter(obj => obj.isComplete === false && obj.status !== 'Disabled')).length > 0 ? 'fa-icon-exclamation-circle' : 'fa-home';
      } else if (navItem === 'autorc2') {
        className = typeof this.navData.tab_buttons !== 'undefined' && (Object.values(this.navData.tab_buttons).filter(obj => (obj.status === 'ActiveIncomplete' || obj.status === 'InactiveIncomplete') && obj.name.toLowerCase() !== "checkout")).length > 0 ? 'fa-icon-exclamation-circle' : 'fa-car';
      } else if (navItem === 'checkout') {
        className = (this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status !== 'Success') || (this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status !== 'Success') ? 'fa-icon-exclamation-circle' : 'fa-shopping-cart-c'
      } else if (navItem === 'condorc2') {
        className = 'fa-hotel';
      } else if (navItem === 'rentersrc2') {
        className = 'fa-building';
      }
      return className;
    },
    /**
     * check if need to display this tab or not based on carrier selected for RC 2 flow
     */
    isPolicyBound() {
      return (this.navData.quote_summary && this.navData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
    },
    /**
     * check if need to display this tab or not based on routes
     */
    checkTabDispCond(navItem) {
      let displayNav = true;
      this.getCarrierWiseRC2Routes;
      let finalArrayToCompare = [];
      
      if(navItem === 'homerc1') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.homerc1routes)
        .concat(this.autorc1routes)
        .concat(this.carriermatchroutes)
        .concat(this.homerc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } if(navItem === 'condorc1') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.condorc1routes)
        .concat(this.autorc1routes)
        .concat(this.carriermatchroutes)
        .concat(this.condorc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } if(navItem === 'rentersrc1') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.rentersrc1routes)
        .concat(this.autorc1routes)
        .concat(this.carriermatchroutes)
        .concat(this.rentersrc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } else if(navItem === 'autorc1') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.autorc1routes)
        .concat(this.carriermatchroutes)
        .concat(this.homerc2routes)        
        .concat(this.condorc2routes)
        .concat(this.rentersrc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } else if(navItem === 'listing') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.carriermatchroutes)
        .concat(this.homerc2routes)
        .concat(this.autorc2routes)        
        .concat(this.condorc2routes)
        .concat(this.rentersrc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } else if(navItem === 'homerc2') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.homerc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
        displayNav = Boolean(this.getHomeCarrierName);//typeof this.getHomeCarrierName !== 'undefined';
      } else if(navItem === 'condorc2') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.condorc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
        displayNav = Boolean(this.getHomeCarrierName);//typeof this.getHomeCarrierName !== 'undefined';
      } else if(navItem === 'rentersrc2') {
        finalArrayToCompare = finalArrayToCompare        
        .concat(this.rentersrc2routes)
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
        displayNav = Boolean(this.getHomeCarrierName);//typeof this.getHomeCarrierName !== 'undefined';
      } else if(navItem === 'autorc2') {// typeof this.getAutoCarrierName !== 'undefined'
        finalArrayToCompare = finalArrayToCompare
        .concat(this.autorc2routes)
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
        displayNav = Boolean(this.getAutoCarrierName);//typeof this.getAutoCarrierName !== 'undefined';
      } else if(navItem === 'nonendtoend') {
        finalArrayToCompare = this.autorc2routes;
      } else if(navItem === 'checkout') {
        finalArrayToCompare = finalArrayToCompare
        .concat(this.checkoutroutes)
        .concat(this.confirmationroutes);
      } else if(navItem === 'confirmation') {
        finalArrayToCompare = this.confirmationroutes;
      }
    //  console.log(navItem ,'==============', this.$router.currentRoute.path, finalArrayToCompare);
      if(finalArrayToCompare.includes(this.$router.currentRoute.path)) {
        return displayNav;
      }
      return false;
    },
    checkCurrentBreadcrumb(navItem) {
      let currentNavItem = '';
      if (this.homerc1routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'homerc1';
      } else if (this.condorc1routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'condorc1';
      } else if (this.rentersrc1routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'rentersrc1';
      } else if (this.autorc1routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'autorc1';
      } else if (this.carriermatchroutes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'listing';
      } else if (this.homerc2routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'homerc2';
      } else if (this.autorc2routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'autorc2';
      } else if (this.condorc2routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'condorc2';
      } else if (this.rentersrc2routes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'rentersrc2';
      } else if (this.checkoutroutes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'checkout';
      } else if (this.confirmationroutes.includes(this.$router.currentRoute.path)) {
        currentNavItem = 'confirmation';
      } 
      if(currentNavItem === navItem) {
        sessionStorage.setItem('currentNav', currentNavItem);
        return "active";
      }
      return "";
    },
    breadcrumbRedirectTo(redirectURL) {
      let currentActiveFlow =  "";
      if(this.homerc1routes.includes(this.$router.currentRoute.path) || this.homerc2routes.includes(this.$router.currentRoute.path)) {
        currentActiveFlow = "homerc1";
      } else if(this.autorc1routes.includes(this.$router.currentRoute.path) || this.autorc2routes.includes(this.$router.currentRoute.path)) {
        currentActiveFlow = "autorc1";
      } else if(this.$router.currentRoute.path === '/home/carrier-matches' || this.$router.currentRoute.path === '/auto/carrier-matches') {
        currentActiveFlow = "listing";
      } else if(this.condorc1routes.includes(this.$router.currentRoute.path) || this.condorc2routes.includes(this.$router.currentRoute.path)) {
        currentActiveFlow = "condorc1";
      } else if(this.rentersrc1routes.includes(this.$router.currentRoute.path) || this.rentersrc2routes.includes(this.$router.currentRoute.path)) {
        currentActiveFlow = "rentersrc1";
      }
      // console.log('this.navData===', this.navData);
      let currentRc2ToNav = sessionStorage.getItem('currentRc2ToNav');
      let rc2tabs = ['hocoverage', 'hopolicydetails'];
      let rateCall = rc2tabs.includes(currentRc2ToNav) && sessionStorage.getItem('currentNav') === 'homerc2' ? 'RC2' : 'RC1';
      
      let HOQuoteId = sessionStorage.getItem('homeSessionData') ? JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId : '';
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;     
      let COQuoteId = sessionStorage.getItem('condoSessionData') ? JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId : '';
      let REQuoteId = sessionStorage.getItem('renterSessionData') ? JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId : '';
      
      let onClick = '';
      if (this.$router.currentRoute.path === '/renters/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/auto/non-end-to-end' || this.$router.currentRoute.path.includes('/checkout') || this.$router.currentRoute.path.includes('/confirmation')) {
        this.breadcrumbNavigateTo(redirectURL, currentActiveFlow, HOQuoteId, AUQuoteId, COQuoteId, REQuoteId);
      } else {
        if (rateCall !== 'RC2') {
          this.$store.dispatch('setRc2NavFlowAction', false);
          sessionStorage.setItem('setRc2NavFlowAction', false);
          for (var i=0; i < this.navData.tab_buttons.length; i++) { 
            let carriercodeprefix = this.carrierCode === 'nationwide' ? 'nwid' : this.carrierCode;
            let pagename = sessionStorage.getItem('currentNav') === 'autorc2' ? carriercodeprefix + this.navData.tab_buttons[i].name : this.navData.tab_buttons[i].name;
            if (pagename === this.$store.getters.getPageName) {
              onClick = this.navData.tab_buttons[i].on_click;
              break;
            }
          }
          /*
          * set page load start time in store
          */
          this.$store.dispatch('setStartTime');
          const currentNavLink = this.$store.getters.getNavLink;
          
          const formData = commonService.getFormData(this.navData);
          const requestParams = {
            url: onClick,//nData.on_click,
            data: formData,
          };
          postData.navigationFormPost(requestParams).then((response) => {
            if (response.data) {
              this.breadcrumbNavigateTo(redirectURL, currentActiveFlow, HOQuoteId, AUQuoteId, COQuoteId, REQuoteId);
            }
          });
        } else {
          let pagename = currentRc2ToNav;
          // if(this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound')
          if (!this.isPolicyBound()) {
            let patchURL = '';
            const patchAPIRC2 = 'HORateCall2Details';
            const patchAPIRC3 = 'HOBindCallDetails';
            const pageNameFromAPI = this.$store.getters.getPageName;
            //Checking if tab is coming from confirmation page then it should not call Patch API
            if (pageNameFromAPI.includes('HOPostBindCallDetails')) {
              this.$router.replace(commonService.getRouteName(`/Property/${pagename}/tp`));
              this.$store.dispatch('sethomeRc2Nav', pagename);
              sessionStorage.setItem('sethomeRc2Nav', pagename);
            } else {
              if (pageNameFromAPI.includes(patchAPIRC2))
                patchURL = '/pages/HORateCall2Details/';
              else if (pageNameFromAPI.includes(patchAPIRC3))
                patchURL = '/pages/HOBindCallDetails/';
              const requestParams = {
                url: `${patchURL}${HOQuoteId}`,
                data: commonService.getFormData(this.navData),
              };
              patchData.navigationFormPatch(requestParams).then((response) => {
                this.breadcrumbNavigateTo(redirectURL, currentActiveFlow, HOQuoteId, AUQuoteId, COQuoteId, REQuoteId);
              });
            }
          }
          // this.$store.dispatch('setCurrentNav', getUrl);
          // this.$store.dispatch('setRc2NavFlowAction', true);
          // sessionStorage.setItem('setRc2NavFlowAction', true);
          // this.$router.replace(commonService.getRouteName(`/Property/${pagename}/tp`));
          // this.$store.dispatch('sethomeRc2Nav', pagename);
          // sessionStorage.setItem('sethomeRc2Nav', pagename);

        }
      }
    },
    async breadcrumbNavigateTo(redirectURL, currentActiveFlow, HOQuoteId, AUQuoteId, COQuoteId, REQuoteId) {
      let newRoute = '';
      let cuurentNav = '';
      if (redirectURL === 'homerc1') {
        newRoute = '/home/name-insured';
        cuurentNav  = '/pages/honamedinsured/' + HOQuoteId;
      } else if(redirectURL === 'autorc1') {
        newRoute = '/auto/name-insured';
        cuurentNav  = '/pages/namedinsured/' + AUQuoteId;
      } else if(redirectURL === 'condorc1') {       
        newRoute = '/condo/name-insured';
        cuurentNav  = '/pages/conamedinsured/' + COQuoteId;
      } else if(redirectURL === 'rentersrc1') {       
        newRoute = '/renters/name-insured';
        cuurentNav  = '/pages/renamedinsured/' + REQuoteId;
      } else if(redirectURL === 'listing') {
        newRoute = '/auto/carrier-matches';
        cuurentNav = '/pages/carriermatches/' + AUQuoteId;
      } else if(redirectURL === 'homerc2') {
        newRoute = '';//'/home/dwelling';//TODO:check 
        cuurentNav = `/pages/HORateCall2Details/${HOQuoteId}`;   //TODO:check carrierwise
        // if carrier is branch then we dont need to display dwelling tab. Display it for all other carriers
        if (this.getHomeCarrierName.toLowerCase() !== 'branch') {//this.$store.getters.getSelectedHomeCarrier.carrier_id !== 171
          this.$store.dispatch('sethomeRc2Nav', 'hodwelling', cuurentNav);
          sessionStorage.setItem('sethomeRc2Nav', 'hodwelling');
          sessionStorage.setItem('setRc2NavFlowAction', true);
          this.$store.dispatch('setRc2NavFlowAction', true);
          // this.$router.replace(commonService.getRouteName(getUrl));
          let homeCarrierType = this.$store.getters.getSelectedHomeCarrier !== '' && this.$store.getters.getSelectedHomeCarrier !== null ? this.$store.getters.getSelectedHomeCarrier.carrier_type : sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
          if (homeCarrierType === 'EZLYNXCARRIER') {
            sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData')); 
            this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId });
            newRoute = '/home/non-end-to-end';
          } else{
             newRoute = '/home/dwelling';//TODO:check
          }
        } else {
          const rateRequestParams = {
            url: `/pages/horatecall2details/${HOQuoteId}`,
          };
          await fetchData.getPageData(rateRequestParams).then((response) => {
            this.pageData = response.data;
            this.pageFieldsArray = this.pageData.fields;
            if (this.pageFieldsArray.some(field => field.section === 'Primary Mortgage' && field.visible)) {
              this.$store.dispatch('sethomeRc2Nav', 'homortgage');
              sessionStorage.setItem('sethomeRc2Nav', 'homortgage');
              sessionStorage.setItem('setRc2NavFlowAction', true);
              this.$store.dispatch('setRc2NavFlowAction', true);
              sessionStorage.setItem("mortgagehighlight", true);
              // this.$router.replace('/home/mortgage');
              newRoute = '/home/mortgage';
            } else {
              this.$store.dispatch('sethomeRc2Nav', 'hocoverage');
              sessionStorage.setItem('sethomeRc2Nav', 'hocoverage');
              sessionStorage.setItem('setRc2NavFlowAction', true);
              this.$store.dispatch('setRc2NavFlowAction', true);
              sessionStorage.setItem("mortgagehighlight", false);
              // this.$router.replace('/home/coverage');
              newRoute = '/home/coverage';
            }
          });
        }
      } else if(redirectURL === 'condorc2') {
        let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
        if (homeCarrierType === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData')); 
          newRoute = '/condo/non-end-to-end';
        }
      } else if(redirectURL === 'rentersrc2') {
        let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
        if (homeCarrierType === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData')); 
          newRoute = '/renters/non-end-to-end';
        }
      } else if(redirectURL === 'autorc2') {  
        let autoCarrierType = this.$store.getters.getSelectedAutoCarrier != '' && this.$store.getters.getSelectedAutoCarrier !== null ? this.$store.getters.getSelectedAutoCarrier.carrier_type : sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
        if (autoCarrierType === 'EZLYNXCARRIER') {
             sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
             this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
             newRoute = '/auto/non-end-to-end';
        } else {   
          let navigateURL = JSON.parse(sessionStorage.getItem('autoRC1BindResponse')).Navigate;
          newRoute = commonService.getRouteName(navigateURL);//'/auto/nationwide/rc2-contact-details';
          cuurentNav  = navigateURL;//'/pages/nwidpolicydetails/' + AUQuoteId;
        }       
      } else if(redirectURL === 'checkout') {
        newRoute = '/auto/bundle/checkout';
        cuurentNav = '';        
      } else if(redirectURL === 'confirmation') {
        
      }
      sessionStorage.setItem('currentNav', redirectURL);
      if(currentActiveFlow !== redirectURL) {            
        if (redirectURL === 'autorc1' || redirectURL === 'autorc2' || redirectURL === 'listing') { //Home to auto navigation
          this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
        } else if ((redirectURL === 'homerc1' || redirectURL === 'homerc2')) { //auto to home navigation
          this.$store.dispatch('setSessionQuote', { SessionId: HOQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData'));
        } else if (redirectURL === 'condorc1' || redirectURL === 'condorc2') { //auto to condo navigation
          this.$store.dispatch('setSessionQuote', { SessionId: COQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('condoSessionData'));
        } else if (redirectURL === 'rentersrc1' || redirectURL === 'rentersrc2') { //auto to renters navigation
          this.$store.dispatch('setSessionQuote', { SessionId: REQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('renterSessionData'));
        }
      }
      this.$store.dispatch('setCurrentNav', cuurentNav);
      this.$router.push(newRoute);
    }
  },
  watch: {    
    navData: (val) => {
      const tabBtns = val.tab_buttons;

      tabBtns.forEach((element) => {
        const e = element;
        if (e.status.indexOf('Disabled') !== -1) {
          e.screenReaderDesc = 'Page Disabled';
        } else if (e.status.indexOf('Incomplete') !== -1) {
          e.screenReaderDesc = 'Page Incomplete';
        } else if (e.status.indexOf('Complete') !== -1) {
          e.screenReaderDesc = 'Page Complete';
        } else {
          e.screenReaderDesc = '';
        }
      });
    },
  }
}
</script>
<style scoped lang="scss">
 .container-breadcrumb {
    ul {
      margin: 6px 16px; //actual is 12px top bottom
    } 
    li {
      vertical-align: middle;
      cursor: pointer;
    .label {
      color:#0054AD;
      &:hover {
        text-decoration: underline !important;
      }
    }
    .fas {
      color: #000000;
      opacity: 0.5;
      &:not(.fa-chevron-right) {
        font-size: 16px;
      }
    }
    &.active {
      pointer-events: none;
      .fas:not(.fa-chevron-right){     
        color: rgba(0, 0, 0, 0.87);   
        opacity: unset;
      }
      // .fa-home-auto-bundle-search {
      //   background-color: rgba(0, 0, 0, 0.87);
      // }
      .label {
        color: rgba(0, 0, 0, 0.87);
        font-weight: 600;
      }
    }
  }
  .fa-icon-exclamation-circle {
    position: relative;
    top: 3px;
  }
  .fa-shopping-cart-c {
    position: relative;
    top: 2px;
  }
  .fa-home-auto-bundle-search, 
  .fa-condo-auto-bundle-search, 
  .fa-renter-auto-bundle-search  {
    background-color: #707070;
    height: 16px;
    width: 16px;
    position: relative;
    top: 2px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/shared/Breadcrumbs.vue?a830c916